import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import toast from 'react-hot-toast';
import { postRequest } from '../../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../../authContext/context';
import { useDispatch } from 'react-redux';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'


export default function CreateLenderPanel() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [lenderNumbers, setLenderNumbers] = React.useState(['']);


  const handleAddLenderNumber = () => {
    setLenderNumbers([...lenderNumbers, '']);
  };

  const handleRemoveLenderNumber = (index) => {
    const updatedNumbers = lenderNumbers.filter((_, i) => i !== index);
    setLenderNumbers(updatedNumbers);
  };

  const handleLenderNumberChange = (index, value) => {
    const updatedNumbers = [...lenderNumbers];
    updatedNumbers[index] = value;
    setLenderNumbers(updatedNumbers);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // Filter out empty lender numbers
      const filteredNumbers = lenderNumbers.filter(num => num.trim() !== '');

      const payload = {
        name: data?.name,
        lender_numbers: filteredNumbers,
      };

      const response = await postRequest('private/createLendelPanel', payload, authCtx.token);
      console.log(response, 'response');

      if (response?.status == 200) {
        navigate('/lenderPanels');
      } else {
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
         <BreadcrumbsWrapper
                                                    items={[
                                                      { label: 'Dashboard', path: '/dashboard' },
                                                      { label: 'LenderPanles', path: '/lenderPanels' },
                                                      { label: 'CreateLenderPanel', path: '' },
                                                    ]}
                                                  />
                                            <br></br>
      <div className="page-header pb-3">
        <h1 className="mt-0 mb-0">Add New Lender Panel</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">

            <Form.Group as={Col} controlId="name">
              {/* <Form.Label>Name</Form.Label> */}
              <Form.Control
                type="text"
                placeholder="Name of lender panel"
                {...register('name', { required: 'Name is required' })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Lender Numbers</Form.Label>
              {lenderNumbers.map((number, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <Form.Control
                    type="text"
                    placeholder="Lender Number"
                    value={number}
                    onChange={(e) => handleLenderNumberChange(index, e.target.value)}
                    style={{ marginRight: '10px' }}
                  />
                  {lenderNumbers.length > 1 && (
                    <IconButton
                      color="error"
                      onClick={() => handleRemoveLenderNumber(index)}
                      size="small"
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  )}
                  {index === lenderNumbers.length - 1 && (
                    <IconButton
                      color="primary"
                      onClick={handleAddLenderNumber}
                      size="small"
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  )}
                </div>
              ))}
            </Col>
          </Row>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/lenderPanels')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize'
  type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}
